import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import { FormBox, FormGroupAdapter, FormFlex, FormLegend } from 'components/shared/form';

import { SIGNATURE_INITIAL_VALUES, SIGNATURE_CHECKBOX_LABEL_VERSIONS } from 'constants/forms';
import { validateAccepted } from 'utils/validates';

import { LegendFormFlex, StyledTextarea, TextMuted } from '.';

const propTypes = {
  disabled: PropTypes.bool,
  signatureVersion: PropTypes.string,
  acknowledgmentCheckboxesVersion: PropTypes.string,
};

const defaultProps = {
  disabled: true,
  signatureVersion: 'v1',
  acknowledgmentCheckboxesVersion: 'v2',
};

function CreditAndBackgroundRelease({ disabled, signatureVersion, acknowledgmentCheckboxesVersion }) {
  return (
    <Fragment>
      <LegendFormFlex justifyContent="space-between">
        <FormBox>
          <FormLegend>
            Credit and Background Release
            <TextMuted>We will not run this until after we speak with you personally</TextMuted>
          </FormLegend>
        </FormBox>
      </LegendFormFlex>

      <FormFlex>
        <FormBox width={1}>
          <StyledTextarea
            rows={5}
            disabled
            value={SIGNATURE_INITIAL_VALUES[signatureVersion].creditAndBackgroundRealease}
          />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <Field
            name="application.borrower.creditAndBackgroundRealease"
            type="checkbox"
            label={SIGNATURE_CHECKBOX_LABEL_VERSIONS[acknowledgmentCheckboxesVersion].creditAndBackgroundRealease}
            inlineGroup
            labelOrder={1}
            errorOrder={2}
            required
            disabled={disabled}
            validate={validateAccepted()}
            component={FormGroupAdapter}
          />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

CreditAndBackgroundRelease.propTypes = propTypes;
CreditAndBackgroundRelease.defaultProps = defaultProps;

export default CreditAndBackgroundRelease;
